import { render, staticRenderFns } from "./UVEX.vue?vue&type=template&id=687841e1&"
import script from "./UVEX.vue?vue&type=script&lang=js&"
export * from "./UVEX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports